import { useQuery } from "@tanstack/react-query";
import { getCommunityDashboard } from "../api/community-api";

export const useCommunityDashboard = () => {
	return useQuery({
		queryKey: ["analytics", "community"],
		queryFn: getCommunityDashboard,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false
	});
};
